import React, { Component } from "react";
import Banner from "./banner";
import About from "./about";
import Treatment from "./treatment";
import Testimonial from "./testimonial";
import Gallery from "./gallery";
import { Helmet } from "react-helmet";
import Calender from "../healthTrackerCalender/health-trackers"

export default class home extends Component {
    constructor(props) {
        super(props);
        this.state = {
          bannerData: [],
          AboutListData: [],
          SpecialitiesList: [],
          centreData:[],
          bouquetData:[],
        };
      }


      componentDidMount() {
        const bannerData = JSON.parse(window.sessionStorage.getItem("Banner"));  
        const AboutList= JSON.parse(window.sessionStorage.getItem("About"));  
        const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
        const SpecialitiesData = JSON.parse(window.sessionStorage.getItem("Specialities"));
        const Bouquet = JSON.parse(window.sessionStorage.getItem("Bouquet"));
    
        if (bannerData) {
          this.setState({ bannerData: bannerData[0].sectionList });
        }
        if (AboutList) {
          this.setState({ AboutListData: AboutList[0].sectionList });
        }
        if (Centre) {
          this.setState({ centreData: Centre[0].sectionList });
        }
        if (SpecialitiesData) {
          this.setState({ SpecialitiesList: SpecialitiesData[0].sectionList });
        }
        if (Bouquet) {
          this.setState({ bouquetData: Bouquet[0].sectionList });
        }

    //const script = window.sessionStorage.getItem("google_analytics_script");//document.createElement("script");
    //script.src = window.sessionStorage.getItem("google_analytics_script");
    //script.async = true;
   // document.head.appendChild(script);

      }
    
    render() {
         
        return (
          <div class="mentalHealthWrap">
            
        <Helmet>
        
        
          <title>{window.sessionStorage.getItem("seo_title")}</title>
          <meta name="description" content={window.sessionStorage.getItem("seo_description")} />
          <meta name="keywords" content={window.sessionStorage.getItem("seo_keywords")} ></meta>
          <meta name="twitter:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="twitter:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="twitter:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta name="facebook:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="facebook:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="facebook:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta property="og:title" content={window.sessionStorage.getItem("seo_title")} ></meta>
          <meta property="og:image" content={window.sessionStorage.getItem("siteLogo")} ></meta>
          <meta property="og:description" content={window.sessionStorage.getItem("seo_description")} ></meta>
          <meta property="og:url" content={window.sessionStorage.getItem("slug")} ></meta>
          
          
        </Helmet>
        
            <div className="pamba-wrapper">
                {this.state.bannerData.length > 0 ?
                <Banner />
                : ''}
                 {this.state.AboutListData.length > 0 ?
                <About />
                : ''}

               {this.state.SpecialitiesList.length > 0 ? 
                <Treatment/>
                : ''}
                {this.state.bouquetData.length > 0 ?
                <Gallery />
                : ''}
                {this.state.centreData.length > 0 ?
                <Testimonial />
                : ''}

                {window.sessionStorage.getItem("hasHealthTracker")==='true' && (  
                 <Calender />
                 )}  
            </div>
            </div>
        );
    }
}